import React from 'react';
import { FaAward, FaCheckCircle, FaClock, FaCalendarCheck, FaStar } from 'react-icons/fa';

export const ProDashSummary = ({ profile, professionalType, stats }) => (
  <>
    {/* Welcome Banner */}
    <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl p-6 mb-8 text-white">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold mb-1">Welcome, {profile?.name}!</h1>
          <p className="text-blue-100">{professionalType} • {profile?.company}</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {profile?.founding_advisor && (
            <span className="flex items-center gap-1 px-3 py-1 bg-amber-400 text-amber-900 rounded-full text-sm font-bold" data-testid="founding-advisor-badge">
              <FaAward />
              Founding Advisor
            </span>
          )}
          {profile?.status === 'approved' && profile?.credentials_verified ? (
            <span className="flex items-center gap-1 px-3 py-1 bg-emerald-500 rounded-full text-sm">
              <FaCheckCircle />
              Verified Professional
            </span>
          ) : (
            <span className="flex items-center gap-1 px-3 py-1 bg-amber-500 rounded-full text-sm">
              <FaClock />
              {profile?.status}
            </span>
          )}
        </div>
      </div>
    </div>

    {/* Stats Cards */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <div className="bg-white rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
            <FaCalendarCheck className="text-blue-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{stats.upcoming}</p>
            <p className="text-xs text-gray-500">Upcoming</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
            <FaCheckCircle className="text-emerald-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{stats.completed}</p>
            <p className="text-xs text-gray-500">Completed</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
            <FaClock className="text-amber-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{stats.pending}</p>
            <p className="text-xs text-gray-500">Pending</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
            <FaStar className="text-purple-600" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{profile?.rating?.toFixed(1) || '5.0'}</p>
            <p className="text-xs text-gray-500">Rating</p>
          </div>
        </div>
      </div>
    </div>
  </>
);
